<template>
  <div v-if="relationship">
    Remove {{ relationship.friendlyRelationDisplay }} {{ relationship.inverse_label_title }} from
    <span v-html="inverseModelTitles"></span> model(s)
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import triggerBaseMixin from '../mixins/trigger-base-mixin';
  import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";
  import selectedMixin from "../mixins/selectedMixin";
  import Pluralizeable from "~/mixins/pluralizeable";
  import {ArrayHelper} from "~/helpers/arrayHelper";
  import ObjectModel from "~/models/objectModel";
  import {RouteHelper} from "~/helpers/routeHelper";
  import {Route} from "~/enums/route";

  export default Vue.extend({
    mixins: [triggerBaseMixin, selectedMixin, Pluralizeable],
    computed: {
      relationship(): ObjectModelRelation {
        return this.selectedObjectModel.objectModelRelationsArray.find(relation => {
          return relation.id === this.objectModelTrigger.relationship_id
        })
      },
      inverseModelTitles(): string {
        return ArrayHelper.toSentence<ObjectModel>(this.relationship.related_object_models, ', ', 'and', (model) => {
          return this.editModelRelationsLinkHtml(model);
        })
      }
    },
    methods: {
      editModelRelationsLinkHtml(model: ObjectModel): string {
        return this.linkHtml(model, RouteHelper.path({route: Route.editObjectModelRelationships, modelOrId: model}));
      },
      linkHtml(model: ObjectModel, route: string): string {
        return `<a href="${route}" class="btn-link">${model.title}</a>`;
      },
    }
  });
</script>